export { default } from './Embed';
